import { render, staticRenderFns } from "./WxxdConf.vue?vue&type=template&id=77c51639"
import script from "./WxxdConf.vue?vue&type=script&lang=js"
export * from "./WxxdConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports